import { Component, Input } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import { NzBadgeComponent } from "ng-zorro-antd/badge";
import { NzButtonComponent } from "ng-zorro-antd/button";
import { NzWaveDirective } from "ng-zorro-antd/core/wave";
import {
	NzDropdownDirective,
	NzDropdownMenuComponent,
} from "ng-zorro-antd/dropdown";
import { NzEmptyModule } from "ng-zorro-antd/empty";
import { NzIconDirective } from "ng-zorro-antd/icon";
import { AuthApi } from "../../../domain/api/auth.api";
import { NotificationApi } from "../../../domain/api/notification.api";
import { dateWithTimeZoneToYYYYMMDD } from "../../../domain/helper/date.helper";
import { UUID } from "../../../domain/model/entityReference.model";
import { Notification } from "../../../domain/model/notification.model";
import { Router } from "../../../domain/service/router/router";
import { StateReplacePipe } from "../pipe/state-replace.pipe";
import { TranslateIfKeyPipe } from "../pipe/translate-if-key.pipe";
import { BaseComponent } from "./base.component";

@Component({
	selector: "app-notifications-toolbar",
	imports: [
		TranslateIfKeyPipe,
		NzBadgeComponent,
		NzDropdownDirective,
		NzDropdownMenuComponent,
		NzIconDirective,
		StateReplacePipe,
		NzButtonComponent,
		NzWaveDirective,
		NzEmptyModule,
		TranslocoPipe,
	],
	template: `
    @if (myNotifications && myNotifications.length > 0) {
      <span nz-dropdown [nzPlacement]="'bottomCenter'" class="cursor-pointer"
            [nzDropdownMenu]="notificationsDDM">
        <nz-badge class="align-middle" [nzCount]="myNotifications.length">
          <span nz-icon nzType="bell" nzTheme="outline" class="text-2xl"></span>
        </nz-badge>
      </span>
    } @else {
      <span [nzDropdownMenu]="notificationsDDM" nz-dropdown [nzPlacement]="'bottomCenter'">
        <span nz-icon nzType="bell" nzTheme="outline" class="align-middle text-2xl cursor-pointer"></span>
      </span>
    }

    <nz-dropdown-menu #notificationsDDM="nzDropdownMenu" class="max-h-14">
      <div class=" w-full bg-white  shadow max-h-72  min-h-14 overflow-y-scroll min-w-60  ">
        @if (myNotifications && myNotifications.length > 0) {
          <button class="h-full max-h-12 w-full" nz-button nzDanger nzType="primary"
                  (click)="removeAllNotification()">
            <span class="text-lg">{{ 'notifications.toolbar.removeAll' | transloco }}</span>
          </button>
          <ul>
            @for (notification of myNotifications; track notification.id) {
              <li class="flex px-4 py-2 w-full hover:bg-gray-100 cursor-pointer">
                <div class="w-52 flex flex-col items-start align-sub gap-1"
                     (click)="navigateNotification(notification.link,notification.id)">
                  <div class="font-bold w-full h-full">{{ notification.title | translateIfKey: 'notifications.titles' }}</div>
                  <div class="w-full">{{ notification.message | stateReplace }}</div>
                  <div
                    class="italic justify-end text-xs w-24 h-full"> {{ dateWithTimeZoneToYYYYMMDD(getCreatedAtDate(notification.createdAt)) }}
                  </div>
                </div>
                <div class="flex w-1/4 items-center">
                    <span nz-icon nzType="delete" nzTheme="fill" [nzTheme]="'twotone'"
                          [nzTwotoneColor]="'#eb2f96'" (click)="removeNotification(notification.id)"
                          class="text-2xl color-red ml-2 justify-end hover:bg-gray-200 rounded-full w-fit h-fit p-2"></span>
                </div>
              </li>
            }
          </ul>
        } @else {
          <div class="p-4">
            <nz-empty [nzNotFoundContent]="contentTpl">
              <ng-template #contentTpl>
                <span>{{ 'notifications.toolbar.empty' | transloco }}</span>
              </ng-template>
            </nz-empty>
          </div>
        }
      </div>
    </nz-dropdown-menu>
  `,
})
export class NotificationsToolbarComponent extends BaseComponent {
	@Input() myNotifications: Notification[] | undefined = [];
	dateWithTimeZoneToYYYYMMDD = dateWithTimeZoneToYYYYMMDD;

	constructor(
		private readonly notificationApi: NotificationApi,
		private readonly router: Router,
		private readonly authApi: AuthApi,
	) {
		super();
	}

	override onChanges() {
		super.onChanges();
		if (this.myNotifications) {
			this.myNotifications?.sort(
				(a, b) =>
					new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
			);
		}
	}

	async navigateNotification(link: string, id: string) {
		await this.router.navigate([
			"/" + this.router.namespace(),
			...link.split("/"),
		]);
		await this.removeNotification(id);
	}

	async removeNotification(id: string) {
		await this.notificationApi.updateNotificationIsRead({
			id: id as UUID,
			read: true,
		});
	}
	async removeAllNotification() {
		await this.notificationApi.updateNotificationsAreRead({
			userId: this.authApi.me()()!.id,
			read: true,
		});
	}

	getCreatedAtDate(createdAt: string) {
		return new Date(createdAt);
	}
}
